// @generated by protoc-gen-es v1.10.0
// @generated from file ibc/core/channel/v1/upgrade.proto (package ibc.core.channel.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Order, Timeout } from "./channel_pb.js";

/**
 * Upgrade is a verifiable type which contains the relevant information
 * for an attempted upgrade. It provides the proposed changes to the channel
 * end, the timeout for this upgrade attempt and the next packet sequence
 * which allows the counterparty to efficiently know the highest sequence it has received.
 * The next sequence send is used for pruning and upgrading from unordered to ordered channels.
 *
 * @generated from message ibc.core.channel.v1.Upgrade
 */
export const Upgrade = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.Upgrade",
  () => [
    { no: 1, name: "fields", kind: "message", T: UpgradeFields },
    { no: 2, name: "timeout", kind: "message", T: Timeout },
    { no: 3, name: "next_sequence_send", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * UpgradeFields are the fields in a channel end which may be changed
 * during a channel upgrade.
 *
 * @generated from message ibc.core.channel.v1.UpgradeFields
 */
export const UpgradeFields = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.UpgradeFields",
  () => [
    { no: 1, name: "ordering", kind: "enum", T: proto3.getEnumType(Order) },
    { no: 2, name: "connection_hops", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * ErrorReceipt defines a type which encapsulates the upgrade sequence and error associated with the
 * upgrade handshake failure. When a channel upgrade handshake is aborted both chains are expected to increment to the
 * next sequence.
 *
 * @generated from message ibc.core.channel.v1.ErrorReceipt
 */
export const ErrorReceipt = /*@__PURE__*/ proto3.makeMessageType(
  "ibc.core.channel.v1.ErrorReceipt",
  () => [
    { no: 1, name: "sequence", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

